import { ConfirmationContent } from './ConfirmationContent';

export class ConfirmationInputInfo {
    Visibility: boolean;
    ConfirmationContent: ConfirmationContent;
}